import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { AUTOMATION_LOADS } from './actions';
import { BULK_CAPACITY_MATCH_JOB_TABLE } from 'cargo-chief-commons';

export const reducers = createReducer(
	initialState,
	on(AUTOMATION_LOADS.LOADS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(AUTOMATION_LOADS.LOADS_LIST.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		loadsList: BULK_CAPACITY_MATCH_JOB_TABLE(action.data, state.activeUsersList),
		total: action.totalElements,
	})),
	on(AUTOMATION_LOADS.LOADS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
	})),

	on(AUTOMATION_LOADS.CARRIER_OFFER_STATUS.SET_CARRIERS_OFFER_STATUS, (state, action) => ({
		...state,
		currentCarrierOffersStatus: action.data,
	})),

	on(AUTOMATION_LOADS.CARRIER_OFFER_STATUS.SET_BA_ACCOUNT_SETTING_DISABLED, (state, action) => ({
		...state,
		baAccountSettingDisabled: action.setting,
	})),

	on(AUTOMATION_LOADS.USERS_LIST.SET, (state, action) => ({
		...state,
		activeUsersList: action.usersList,
	}))
);
